export default "__VITE_ASSET__vN3yu2_Z__"